export const MAX_FILE_COUNT = 6;
export const SHOW_CHRISTMAS_THEME = false;
export const INSTALL_APP_BANNER_TIME = 8000;
export const LOCAL_USER_KEY = "user";
export const LOCAL_AUTH_TYPE = "authType";
export const THEME_KEY = "THEME";
export const LOCAL_GRADE_FILE_KEY = "GRADE_FILE";
export const LOCAL_GRADE_MAP_ID = "GRADE_MAP_ID";
export const INSTALL_APP_BANNER_VISIBLE = false;

// Affiliate (tiếp thị liên kết)
export const AFFILIATE_ENABLED = true; // kill switch toàn hệ
export const LOCAL_AFFILIATE_STATE_KEY = "AFFILIATE_STATE";
export const AFFILIATE_DISMISS_DAYS = 14;
export const AFFILIATE_MAX_IMPRESSIONS_PER_DAY = 3;
export const AFFILIATE_CLICK_COOLDOWN_DAYS = 30;
export const AFFILIATE_IMPRESSION_DWELL_MS = 1000;
export const AFFILIATE_INTERSTITIAL_ENABLED = true; // kill switch riêng
export const AFFILIATE_INTERSTITIAL_COUNTDOWN = 5; // giây trước khi hiện nút đóng
export const AFFILIATE_INTERSTITIAL_MIN_NAVIGATIONS = 3;
export const AFFILIATE_INTERSTITIAL_COOLDOWN_HOURS = 24;

export const RING_CHART_COLOR_CONFIG = ["#FF9999", "#FFF4F4"];

export interface GradeItem {
  from: number;
  to: number;
  asNumber: number;
  asString: string;
}

export const GRADE_MAPS: GradeItem[][] = [
  [
    {
      from: 0,
      to: 4,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 4,
      to: 5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 5,
      to: 5.5,
      asNumber: 1.5,
      asString: "D+",
    },
    {
      from: 5.5,
      to: 6.5,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 6.5,
      to: 7,
      asNumber: 2.5,
      asString: "C+",
    },
    {
      from: 7,
      to: 8,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 8,
      to: 8.5,
      asNumber: 3.5,
      asString: "B+",
    },
    {
      from: 8.5,
      to: 9,
      asNumber: 3.7,
      asString: "A",
    },
    {
      from: 9,
      to: 10,
      asNumber: 4,
      asString: "A+",
    },
  ],
  [
    {
      from: 0,
      to: 4,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 4,
      to: 5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 5,
      to: 5.5,
      asNumber: 1.5,
      asString: "D+",
    },
    {
      from: 5.5,
      to: 6.5,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 6.5,
      to: 7,
      asNumber: 2.5,
      asString: "C+",
    },
    {
      from: 7,
      to: 8,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 8,
      to: 8.5,
      asNumber: 3.5,
      asString: "B+",
    },
    {
      from: 8.5,
      to: 10,
      asNumber: 4,
      asString: "A",
    },
  ],
  [
    {
      from: 0,
      to: 4,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 4,
      to: 5.5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 5.5,
      to: 7,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 7,
      to: 8.5,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 8.5,
      to: 10,
      asNumber: 4,
      asString: "A",
    },
  ],
];
